"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavButtonDefaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var NavButton = function NavButton(_ref) {
  var selected = _ref.selected,
      _onClick = _ref.onClick,
      classNames = _ref.classNames,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'nav-button': true,
      'nav-button--selected': selected
    }, classNames),
    role: "button",
    tabIndex: 0,
    onClick: function onClick() {
      if (_onClick) _onClick();
    },
    onKeyDown: function onKeyDown(target) {
      if (target.key === 'Enter') {
        target.currentTarget.click();
      }
    }
  }, children);
};

NavButton.propTypes = {
  selected: _propTypes.default.bool.isRequired,
  classNames: _propTypes.default.any,
  onClick: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)])
};
var NavButtonDefaultProps = {
  selected: false
};
exports.NavButtonDefaultProps = NavButtonDefaultProps;
NavButton.defaultProps = NavButtonDefaultProps;
var _default = NavButton;
exports.default = _default;